import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationApi } from '../../api/ApplicationApi';

//Application thunks

//To get paginated Applications data
export const getApplications = createAsyncThunk(
  'applications/getApplications',
  async (action: { page: number; limit: number; searchCode?: string }, thunkAPI) => {
    return ApplicationApi.getApplications(action, thunkAPI.dispatch);
  }
);

//To create an application
export const createApplication = createAsyncThunk(
  'applications/createApiKey',
  async (action: { request: unknown }, thunkAPI) => {
    return ApplicationApi.createApplication(action, thunkAPI.dispatch);
  }
);

//To Update an application
export const updateApplication = createAsyncThunk(
  'applications/updateApiKey',
  async (action: { request: unknown }, thunkAPI) => {
    return ApplicationApi.updateApplication(action, thunkAPI.dispatch);
  }
);

//To delete an application
export const deleteApplications = createAsyncThunk(
  'applications/deleteApplications',
  async (action: { request: string[] }, thunkAPI) => {
    return ApplicationApi.deleteApplications(action, thunkAPI.dispatch);
  }
);

//To get application details
export const getApplicationDetails = createAsyncThunk(
  'applications/getApplicationDetails',
  async (action: { request: string[]; isActive?: boolean }, thunkAPI) => {
    return ApplicationApi.getApplicationDetails(action, thunkAPI.dispatch);
  }
);
